<template>

    <div class="col-md-6 border-0">
        <div class="ibox dasboard_graph">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
                <div class="clearfix">
                    <div class="left_container">
                        <ul class="title_list">
                            <li class="title-text">Major Payroll Movement</li>
                            <li class="devider_list"><span class="devider"></span></li>
                            <li class="legend_list total_fixed"><span class="text">Total Fixed Pay</span></li>
                            <li class="legend_list total_variable"><span class="text">Total Variable Pay</span></li>
                        </ul>
                    </div>
                    <div class="right_container">
                        <template v-if="payrunsfiscalyear.length > 0">
                            <b-form-select class="dasboard_graph_select" v-model="search.fiscal_year"  @change="setSearchLineFixed()">
                                <option value="null">Select Fiscal Year</option>
                                <option v-for='fyear in payrunsfiscalyear' :value='fyear.fiscal_year'  >{{fyear.fiscal_year }}</option>
                            </b-form-select>
                        </template>
                    </div>

                </div>
            </div>
            <div class="ibox-content">
                <template v-if="show_graph_1 == true">
                    <line-chart :chart-data="linedDatas" :options= "options_line" :styles="myStyles_line"></line-chart>
                </template>
            </div>
        </div>
    </div>

</template>

<script>
    import moment from 'moment';
    export default{

        mounted() {

        },
        props: ['payrunsfiscalyear'],
        components: {

        },
        data(){

            return {
                search:{employee_id:'', pay_slip_name:'', pay_slip_ref:'', fiscal_year:null, month:''},
                linedDatas: null,
                options_line:null,
                myStyles_line:null,
                payrunsapproved:[],
                show_graph_1:false,

            }
        },
        methods:{
            setSearchLineFixed: function(pageflg)
            {
                this.get_fixed_variable_list_graph_data();
            },
            get_fixed_variable_list_graph_data: function()
            {
                this.show_graph_1 = false;
                this.search.type = 'line_fixed';
                //console.log('get_fixed_variable_list_graph_data 0');
                axios.get(this.$api_url+'/list-payruns/1' , {
                params:
                {
                    search_query: this.search,
                }
                }).then(function(response){

                    this.search.type = '';

                    this.payrunsapproved = response.data.data;

                    let fixed_payment = [];
                    let variable_payment = [];
                    let net = [];
                    let month = [];
                    let year = [];



                    for (let x in this.payrunsapproved) {


                        let month_year = '';


                        var month_x = this.payrunsapproved[x].month.replaceAll(',', '') +'-'+this.payrunsapproved[x].year;


                        if(month.indexOf(month_x) !== -1)
                        {
                            var inx = month.indexOf(month_x);

                            fixed_payment[inx] =  fixed_payment[inx] + parseFloat(this.payrunsapproved[x].fixed_payment.replaceAll(',', ''));
                            variable_payment[inx] = variable_payment[inx] + parseFloat(this.payrunsapproved[x].variable_payment.replaceAll(',', ''));

                        }

                        else
                        {
                            month_year = this.payrunsapproved[x].month.replaceAll(',', '') +'-'+this.payrunsapproved[x].year;
                            month.push(month_year);
                            fixed_payment.push(parseFloat(this.payrunsapproved[x].fixed_payment.replaceAll(',', '')));
                            variable_payment.push(parseFloat(this.payrunsapproved[x].variable_payment.replaceAll(',', '')));

                        }


                    }

                    month.reverse();
                    fixed_payment.reverse();
                    variable_payment.reverse();

                    this.lineFiscalYearData(fixed_payment,variable_payment,month);

                    //this.search.type = '';



                }.bind(this));


            },
            lineFiscalYearData: function(fixed,variable,month)
            {

                this.linedDatas={

                labels: month,
                datasets: [
                    {

                        data: fixed,
                        borderColor: '#0060C9',
                        backgroundColor:'rgba(255, 255, 255,0.1)',
                        borderWidth: 5
                    },
                    {

                        data:variable,
                        borderColor: '#072C28',
                        backgroundColor:'rgba(255, 255, 255,0.1)',
                        borderWidth: 5
                    },

                ]

                };



                this.options_line= {
                    responsive: true,
                    maintainAspectRatio: false,
                    lineTension: 1,
                    legend: {
                        display: false
                    },
                    scales: {
                        y: [{
                            ticks: {
                                beginAtZero: true,
                                stepSize: 500000,
                                responsive:true,
                                fontColor: 'red',
                                callback: function(value, index, values) {
                                    console.log('Y ticks value');
                                    console.log(value);
                                    return Number(value).toLocaleString()  ;
                                },
                                color: 'red',

                                },


                        }],
                        x: [{
                            ticks:
                            {
                                fontColor: 'red',
                                label: function(value, index, values)  {
                                    console.log('x ticks value');
                                    console.log(value);
                                    return this.getMonthStr(value);
                                },
                                callback: function(value, index, values) {
                                    return this.getMonthStr(value);
                                }
                            },


                        }],


                    },
                    tooltips: {

                        callbacks: {
                            label: function(tooltipItem, chartData)  {
                                return Number(tooltipItem.value).toLocaleString();
                            },

                        }
                    }
                };

                this.myStyles={


                };

                this.show_graph_1 = true;

            },

        },
        created: function()
        {
            if(this.payrunsfiscalyear.length > 0)
            {
                this.search.fiscal_year=this.payrunsfiscalyear[0].fiscal_year;

                // Abdullah after live added this
                 this.get_fixed_variable_list_graph_data();
            }
        }
    }
</script>
